// src/redux/documentLayoutSlice.js
//
// Kullanıcının elektrik paftası mainFrame içinde dokümanları sürükleyerek
// manuel olarak yeniden sıraladığı durumlar için state.
//
// Mimari:
// - Her doc bir "grup"a aittir (DOC_NAME_TO_GROUP) — örn. "hesaplar", "plan_kat".
// - Grup içinde sıra önemli: useElectricalLayout tryPlaceInCol greedy packing
//   yaptığı için, sıra değişimi otomatik sütun değişimine yol açar (kullanıcı
//   bir doc'u yan sütuna sürüklerse, order değişir → sonraki packing'de farklı
//   sütuna oturur).
// - Sürükleme sadece grup içinde; gruplar arası taşıma KAPSAM DIŞI (kullanıcı
//   kararı).
// - Pin'li doc'lar (DEFAULT_PINNED_DOCS) sürüklenmez (şimdilik).
//
// State:
//   manualGroupOrder: {
//     [groupKey]: [docName, docName, ...]  // Manuel sıralanmış doc isimleri
//   }
//   Bir grup için manuel order yoksa (undefined), defsToRender natural sırası
//   korunur.

import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  manualGroupOrder: {},
};

const documentLayoutSlice = createSlice({
  name: 'documentLayout',
  initialState,
  reducers: {
    // Bir grup için tam doc-isim sırası set et.
    // payload: { groupKey, order: [docName, ...] }
    setManualGroupOrder(state, action) {
      const { groupKey, order } = action.payload || {};
      if (!groupKey || !Array.isArray(order)) return;
      state.manualGroupOrder[groupKey] = order;
    },
    // Tek bir grubun manuel sırasını sil (default natural sıraya dön).
    clearManualGroupOrder(state, action) {
      const groupKey = action.payload;
      if (!groupKey) return;
      delete state.manualGroupOrder[groupKey];
    },
    // Tüm manuel sıraları temizle.
    clearAllManualOrders(state) {
      state.manualGroupOrder = {};
    },
  },
});

export const {
  setManualGroupOrder,
  clearManualGroupOrder,
  clearAllManualOrders,
} = documentLayoutSlice.actions;

// Selectors
export const selectManualGroupOrder = (state) => state.documentLayout?.manualGroupOrder || {};
export const selectManualOrderForGroup = (groupKey) => (state) =>
  state.documentLayout?.manualGroupOrder?.[groupKey] || null;

export default documentLayoutSlice.reducer;
